import type React from 'react';
import ChevronDown from '../../../../../../ui/assets/chevron-down.svg';
import ChevronUp from '../../../../../../ui/assets/chevron-up.svg';
import { MenuItem } from '../../../../../../ui/new-components/MenuItem';
import { useTranslation } from '../../../../i18n/translate/useTranslation';

interface IMenuItemWithSubItemsDropdownProps {
	title: string;
	open: boolean;
	isMobileView?: boolean;
	onClick: () => void;
}

export const SectionParentNavItem = ({
	title,
	open,
	isMobileView,
	onClick,
}: IMenuItemWithSubItemsDropdownProps) => {
	const { t } = useTranslation();

	return (
		<MenuItem
			title={title}
			icon={open ? <ChevronUp aria-hidden /> : <ChevronDown aria-hidden />}
			aria-label={t('nav_item_submenu_label', { title })}
			forceHoverState={open}
			aria-expanded={open}
			role={!isMobileView ? 'menuitem' : undefined}
			onClick={onClick}
		/>
	);
};
